(function () {
    UX.truncateInit = {
        init: function () {
            $('.creative-work__title').not("[data-truncate='none']").truncate({
                lines: 3,
                addClass: 'min-height',
            });

            $('.creative-work .loa').not("[data-truncate='none']").truncate({
                lines: 2,
                type: 'list',
                addClass: 'loa-height',
            });

            $('.featured .grid-item:first-child .creative-work__title').not("[data-truncate='none']").truncate({
                lines: 2,
                addClass: 'min-height',
            });

            $('.card .creative-work__title').not("[data-truncate='none']").truncate({
                lines: 2,
                addClass: 'min-height',
            });

            $('.card .creative-work .loa').not("[data-truncate='none']").truncate({
                lines: 1,
                type: 'list',
                addClass: 'loa-height',
            });

            $(window).on('resized orientationchange', function () {
                $('.creative-work__title, .creative-work .loa').not("[data-truncate='none']").truncate();
            });
        },
    };
})();
